import { useMutation, useQueryClient } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useCreateConnectAction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ connectId, action }: { connectId: number; action: any }) =>
      connectService.createAction(connectId, action),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['connect', 'actions'] });
    }
  });
};
